import React from 'react';
import { Link } from 'react-router-dom';
export function NotFound() {
  return <section className="w-full bg-white" data-id="element-216" data-mp="w3ztfmzgnvxh">
      <div className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center px-6 py-24 text-center" data-id="element-217" data-mp="w52kpw0p40dx">
        <p className="font-display text-[12px] font-bold uppercase tracking-[0.28em] text-gold" data-id="element-218" data-mp="104jpsoc7mvik">
          Page Not Found
        </p>
        <h1 className="mt-3 font-display text-4xl font-black uppercase tracking-tight text-navy" data-id="element-219" data-mp="1a4akaq0rtain">
          We couldn't find that page
        </h1>
        <p className="mt-4 text-[17px] text-gray-600" data-id="element-220" data-mp="1f1kiov650wim">
          The page you're looking for may have moved. Browse our services or get in
          touch for a free quote.
        </p>
        <div className="mt-8 flex flex-col gap-4 sm:flex-row" data-id="element-221" data-mp="1nue1h2ksme18">
          <Link to="/services" className="bg-gold px-8 py-4 font-display text-[13px] font-bold uppercase tracking-widest text-white transition-colors hover:bg-gold-dark" data-id="element-222" data-mp="1susaamu7xs0b">
            View Services
          </Link>
          <Link to="/" className="border border-navy px-8 py-4 font-display text-[13px] font-bold uppercase tracking-widest text-navy transition-colors hover:bg-navy hover:text-white" data-id="element-223" data-mp="1nxf4aprvbp0t">
            Back Home
          </Link>
        </div>
      </div>
    </section>;
}